import React from 'react';
import { StyleSheet, View } from 'react-native';
import { Container, theme, useResponsive } from '@sg/garnish';

import { MenuCollectionsRail } from '@order/components';
import { useLocalizationContext } from '@order/Localization';

// ────────────────────────────────────────────────────────────────────────────────

export const MenuCollections = (props: MenuCollectionsProps) => {
  const { menuCollectionId = '' } = props;

  const { minWidth } = useResponsive();
  const { t } = useLocalizationContext();

  const menuCollectionsWrapperStyle =
    minWidth.tablet && styles.menuCollectionsContainerSM;

  return (
    <View style={styles.menuCollectionsWrapper}>
      <Container style={menuCollectionsWrapperStyle}>
        <MenuCollectionsRail
          headerText={t('menu.collections')}
          menuCollectionId={menuCollectionId}
        />
      </Container>
    </View>
  );
};

// ─── STYLES ─────────────────────────────────────────────────────────────────────

const styles = StyleSheet.create({
  menuCollectionsWrapper: {
    paddingTop: theme.spacing.xlarge,
    backgroundColor: theme.colors.KHAKI_3,
  },
  menuCollectionsContainerSM: {
    paddingTop: theme.spacing.large,
  },
});

// ─── TYPES ──────────────────────────────────────────────────────────────────────

type MenuCollectionsProps = {
  readonly menuCollectionId: string | undefined;
};
